import { useCallback, useState } from 'react';
import { useGetKarsanStockBrandModelOptionsQuery, useGetDealerStockBrandModelOptionsQuery } from '../../../api/endpoints/karsanStockVehiclesReport';

/**
 * Marka/Model cascading dropdown options for stock report filters.
 * @param {Object} options
 * @param {'karsan'|'dealer'} options.variant
 * @param {number|string|null} options.dealerId - Only used for dealer variant (manager filter)
 * @param {boolean} options.enabled - Skip API when false (e.g. tab not visible)
 */
export default function useStockBrandModelOptions({ variant = 'karsan', dealerId = null, enabled = true } = {}) {
    const [selectedBrand, setSelectedBrandState] = useState(null);
    const [selectedModel, setSelectedModelState] = useState(null);

    const karsanQuery = useGetKarsanStockBrandModelOptionsQuery({ brand: selectedBrand || undefined }, { skip: !enabled || variant !== 'karsan' });

    const dealerQuery = useGetDealerStockBrandModelOptionsQuery(
        {
            brand: selectedBrand || undefined,
            dealerId: dealerId || undefined
        },
        { skip: !enabled || variant !== 'dealer' }
    );

    const activeQuery = variant === 'karsan' ? karsanQuery : dealerQuery;

    const setSelectedBrand = useCallback((brand) => {
        setSelectedBrandState(brand || null);
    }, []);

    const setSelectedModel = useCallback((model) => {
        setSelectedModelState(model || null);
    }, []);

    const reset = useCallback(() => {
        setSelectedBrandState(null);
        setSelectedModelState(null);
    }, []);

    return {
        brands: activeQuery.data?.brands ?? [],
        models: activeQuery.data?.models ?? [],
        selectedBrand,
        selectedModel,
        setSelectedBrand,
        setSelectedModel,
        reset,
        isLoading: activeQuery.isFetching || activeQuery.isLoading
    };
}
